import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

//Custom error handler
const errorHandler = (error) => {
  const statusCode = error.response?.status;
  const requestUrl = error.config?.url || "";
  const isAuthLoginRequest =
    requestUrl.includes("/auth/login") ||
    requestUrl.includes("/auth/resend_credentials");

  if (statusCode && statusCode === 401 && !isAuthLoginRequest) {
    console.error(error);
    localStorage.clear();
    window.location.href = "/login";
  }
  return Promise.reject(error);
};

api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error);
});
